import { render, staticRenderFns } from "./VariantsList.vue?vue&type=template&id=c9f6d64c"
import script from "./VariantsList.vue?vue&type=script&lang=js"
export * from "./VariantsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports